import React from 'react';
import {
    MaterialUiCore,
    // @ts-ignore
} from '@gscope-mfe/common-libs';
const { Typography } = MaterialUiCore;

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import download from '../icons/download.svg';
import { CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import classes from './DownloadFrameworkCss.module.css';

const DownloadFrameworkTable = ({
    showTableHead,
    startDownloadFile,
    formatTime,
    filteredDownloadHistory,
    downloadingTransactionId,
}) => {
    return (
        <Table>
            {showTableHead && (
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.bold} align="left">
                            File Details
                        </TableCell>
                        <TableCell className={classes.bold} align="left">
                            Upstream system
                        </TableCell>
                        <TableCell className={classes.bold} align="center">
                            Action
                        </TableCell>
                    </TableRow>
                </TableHead>
            )}
            <TableBody>
                {filteredDownloadHistory && filteredDownloadHistory?.length > 0 ? (
                    filteredDownloadHistory?.map((item) => {
                        return (
                            <TableRow key={item?.transactionId} data-testid="table-row">
                                <TableCell align="left">
                                    <div className={classes.column}>
                                        <Typography
                                            variant="subtitle2"
                                            data-testid="file-name"
                                            className={classes.subTitle}
                                        >
                                            {item?.description || <>--</>}
                                        </Typography>
                                        <div>
                                            {downloadingTransactionId &&
                                            downloadingTransactionId?.length > 0 &&
                                            downloadingTransactionId?.includes(item?.transactionId) ? (
                                                <Typography
                                                    data-testid="in-progress"
                                                    variant="caption"
                                                    className={classes.progress}
                                                >
                                                    <TimerOutlinedIcon fontSize="small" /> In progress
                                                </Typography>
                                            ) : item?.status === 'S' ? (
                                                <Typography data-testid="uploaded" variant="caption">
                                                    <CheckCircleIcon fontSize="small" className={classes.green} />{' '}
                                                    Uploaded | {formatTime(item?.uploadDate)}
                                                </Typography>
                                            ) : item?.status === 'F' ? (
                                                <Typography data-testid="upload-failed" variant="caption">
                                                    <CancelIcon fontSize="small" className={classes.red} /> Upload
                                                    failed | {formatTime(item?.uploadDate)}
                                                </Typography>
                                            ) : item?.status === 'Q' ? (
                                                <Typography
                                                    data-testid="upload-in-queue"
                                                    variant="caption"
                                                    className={classes.queue}
                                                >
                                                    <TimerOutlinedIcon fontSize="small" /> In the queue |{' '}
                                                    {formatTime(item?.uploadDate)}
                                                </Typography>
                                            ) : null}
                                        </div>
                                    </div>
                                </TableCell>
                                {showTableHead && (
                                    <TableCell data-testid="upstream-system" align="left">
                                        {item?.service}
                                    </TableCell>
                                )}
                                <TableCell align="center">
                                    {downloadingTransactionId &&
                                    downloadingTransactionId?.length > 0 &&
                                    downloadingTransactionId?.includes(item?.transactionId) ? (
                                        <CircularProgress
                                            data-testid="download-loading"
                                            style={{ zIndex: '-1' }}
                                            size="20px"
                                        />
                                    ) : (
                                        <button
                                            role="button"
                                            disabled={item?.status === 'S' ? false : true}
                                            onClick={() => startDownloadFile(item?.transactionId, item?.description)}
                                            className={classes.transparent}
                                            tabIndex={0}
                                            data-testid="start-download-button"
                                        >
                                            <img src={download} alt="cross circle" className={classes.twentyWidth} />
                                        </button>
                                    )}
                                </TableCell>
                            </TableRow>
                        );
                    })
                ) : (
                    <TableRow>
                        <TableCell colSpan={3} align="center">
                            <Typography variant="h6">No Records Found</Typography>
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>
        </Table>
    );
};

export default DownloadFrameworkTable;
